import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=63e58480&"
import script from "./Email.vue?vue&type=script&setup=true&lang=js&"
export * from "./Email.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports